var poll_header_default = {
  "title": "XJJWh",
  "image": "JsxS7",
  "webview": "_2WOHL"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
